// @helpers
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @actions
const signaturePatternActions = require('actions/signaturePattern');

// @constants
const {
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    FIRST_STEP,
    CHARGE_ACCOUNT_PREFIX,
    BROKER_DERIVATIVES_MOVEMENTS_CREATE_SIGNATURE_PATTERN
} = require('constants/index');

const {
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_BEGIN_OPERATION,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_CHANGE_DERIVATIVE_ORIGIN,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_CHANGE_AMOUNT,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_VALIDATE_STEP,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_SET_VISIBLE_STEP,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_FINISH,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_FINISH_SUCCESS,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_FINISH_ERROR,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_CHANGE_ACCOUNT,
    BROKER_CREATE_TRANSFER_OF_DERIVATIVES_RESET
} = require('constants/actionTypes');

const reset = () => ({
    type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_RESET
});

const beginOperation = (contractNumber) => (dispatch) => {
    dispatch({
        type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_BEGIN_OPERATION,
        payload: { contractNumber }
    });
};

const changeAccount = (accountId) => ({
    type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_CHANGE_ACCOUNT,
    payload: {
        accountId
    }
});

const changeDerivativeOrigin = (option) => ({
    type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_CHANGE_DERIVATIVE_ORIGIN,
    payload: { option }
});

const changeAmount = (amount) => ({
    type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_CHANGE_AMOUNT,
    payload: { amount }
});

const setVisibleStep = (step) => ({
    type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_SET_VISIBLE_STEP,
    payload: { step }
});

const validateStep = (step) => (dispatch, getState) => {
    dispatch({
        type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_VALIDATE_STEP,
        payload: { step }
    });

    const immBrokerCreateTransferOfDerivatives = getState().brokerCreateTransferOfDerivatives;
    const visibleStep = immBrokerCreateTransferOfDerivatives.get('visibleStep');

    switch (visibleStep) {
        case WIZARD_FIRST_STEP:
            if (immBrokerCreateTransferOfDerivatives.getIn(['steps', FIRST_STEP, 'valid'])) {
                dispatch(setVisibleStep(WIZARD_SECOND_STEP));
            }
            break;
        case WIZARD_SECOND_STEP:
            break;
    }
};

const finishSuccess = (response) => ({
    type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_FINISH_SUCCESS,
    payload: { response }
});

const finishError = (error) => ({
    type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_FINISH_ERROR,
    payload: { error }
});

const onValidSignaturePattern = (dispatch, getState, token) => {
    const immBrokerCreateTransferOfDerivatives = getState().brokerCreateTransferOfDerivatives;
    const immBrokerWallets = getState().brokerWallets;

    const selectedOriginDerivative = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'selectedOriginDerivative']
    );

    const immOriginFuture = immBrokerWallets.get('futuresList').find(
        immFuture => immFuture.getIn(['cviejo', 'numerodecontrato']) === selectedOriginDerivative
    );

    const destinationAccount = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'destinationAccount']
    );

    const immAccount = getState().accounts.getIn(['byId', destinationAccount]);
    const destinationContractNumber = immAccount.get('contractNumber');
    const destinationProduct = immAccount.get('product');
    const accountHolder = immAccount.get('accountHolder');

    const url = apiURLBuilder.getURL('futurosTraspasoAltaConfirmacion');

    const requestData = {
        contratoViejoDestino: {
            numerodecontrato: destinationContractNumber,
            subgrupo: destinationProduct
        },
        contratoViejoOrigen: {
            numerodecontrato: immOriginFuture.getIn(['cviejo', 'numerodecontrato']),
            subgrupo: immOriginFuture.getIn(['cviejo', 'subgrupo'])
        },
        dataToken: token,
        importeCuenta: {
            divisa: immBrokerCreateTransferOfDerivatives.getIn(['steps', FIRST_STEP, 'amountCurrency']),
            importe: immBrokerCreateTransferOfDerivatives.getIn(['steps', FIRST_STEP, 'amount'])
        },
        nombre: accountHolder
    };

    APIPost(dispatch, url, { query: requestData }).then(
        (response) => dispatch(finishSuccess(response)),
        (error) => dispatch(finishError(error))
    );
};

const validateSignaturePattern = (dispatch, getState) => {
    signaturePatternActions.validateAndExecute(dispatch, getState, onValidSignaturePattern).catch(
        (error) => dispatch(finishError(error))
    );
};

const finish = () => (dispatch, getState) => {
    const immBrokerCreateTransferOfDerivatives = getState().brokerCreateTransferOfDerivatives;
    const immBrokerWallets = getState().brokerWallets;

    const selectedOriginDerivative = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'selectedOriginDerivative']
    );

    const destinationAccount = immBrokerCreateTransferOfDerivatives.getIn(
        ['steps', FIRST_STEP, 'destinationAccount']
    );

    const immAccount = getState().accounts.getIn(['byId', destinationAccount]);

    const immOriginFuture = immBrokerWallets.get('futuresList').find(
        immFuture => immFuture.getIn(['cviejo', 'numerodecontrato']) === selectedOriginDerivative
    );

    const originProduct = immOriginFuture.getIn(['cviejo', 'subgrupo']);
    const destinationContractNumber = immAccount.get('contractNumber');
    const destinationProduct = immAccount.get('product');

    const signaturePatternParams = {
        originAccount: `${CHARGE_ACCOUNT_PREFIX}${originProduct}${selectedOriginDerivative}`,
        destinationAccount: `${CHARGE_ACCOUNT_PREFIX}${destinationProduct}${destinationContractNumber}`,
        currency: immBrokerCreateTransferOfDerivatives.getIn(['steps', FIRST_STEP, 'amountCurrency']),
        ammount: immBrokerCreateTransferOfDerivatives.getIn(['steps', FIRST_STEP, 'amount'])
    };

    dispatch({
        type: BROKER_CREATE_TRANSFER_OF_DERIVATIVES_FINISH,
        payload: {}
    });

    dispatch(signaturePatternActions.processRequestConfiguration(BROKER_DERIVATIVES_MOVEMENTS_CREATE_SIGNATURE_PATTERN, signaturePatternParams)).then(
        () => validateSignaturePattern(dispatch, getState),
        (error) => dispatch(finishError(error))
    );
};

module.exports = {
    beginOperation,
    changeAccount,
    changeDerivativeOrigin,
    changeAmount,
    validateStep,
    setVisibleStep,
    finish,
    reset
};
